import icons from './icon-data.js';

export function Icon({ name, size = 24, style, ...rest }) {
  const d = icons[name];
  if (!d) return null;
  return (
    <svg width={size} height={size} viewBox={d.viewBox} fill="none" style={{ display: 'block', flex: '0 0 auto', ...style }} dangerouslySetInnerHTML={{ __html: d.body }} {...rest} />
  );
}
export default Icon;
